<div class="wrapper">
  <app-nav-header></app-nav-header>
  <div class="bg-image">
    <div class="title">
      <div class="title-text">Building High-Impact Software for Your Business Growth</div>
      <div class="sub-text">
        We develop scalable software and mobile solutions that turn complex ideas into powerful tools.
      </div>
      <div class="btn-container">
        <a href="#contactus" class="gradient-btn">
          Contact us
          <mat-icon>arrow_right_alt</mat-icon>
        </a>
      </div>
    </div>
    <div class="animation-wrapper">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
    </div>
  </div>
  <app-services id="services"></app-services>
  <app-works id="works"></app-works>
  <app-about id="about"></app-about>
  <app-statistics></app-statistics>
  <div class="gradient-bg">
    <app-partners></app-partners>
    <app-contact-us id="contactus"></app-contact-us>
  </div>
</div>
<app-footer></app-footer>
